<template>
  <div class="position-relative">
    <div v-if="showSample" class="sample-cover position-absolute"><span class="sample-cover-text">{{ $t('page.no-equipment-record') }}</span></div>
    <div class="toolbox">
      <div class="years-nav">
        <div
          v-for="(item, index) in years"
          :key="index"
          class="year-item"
          :class="[currentYear == item || (!currentYear && index === 0) ? 'active' : '']"
          @click="scrollTo(item)"
        >
          <div class="year-item-icon"></div>
          <span class="year-item-text">
            {{ getLanguage == 'ch'? `${item}年`: item }}
          </span>
        </div>
      </div>
      <div class="filter-tool" :class="[searchKeyword ? 'active' : '']" :style="bgStyle">
        <div class="input-group">
          <span class="input-group-text pe-0"><i class="ri-search-line"></i></span>
          <input type="text" class="form-control search-input" v-model="searchKeyword" @input="debouncedMarkSearch" @keyup.enter="scrollToNext" />
          <div class="input-group-text ps-0 pe-0" v-if="marks.length">
            {{ currentMarkIndex + 1 }}/{{ marks.length }}
          </div>
          <div class="input-group-text arrows">
            <i class="mdi mdi-chevron-up" @click="scrollToPrev"></i>
            <i class="mdi mdi-chevron-down" @click="scrollToNext"></i>
          </div>
        </div>
      </div>
    </div>
    <!--  timeline区域-->
    <div ref="tlWrap" class="tl-wrap" :style="bgStyle">
      <div
        class="tl-row"
        v-for="(rowItem, rowIndex) in timeLineNodes"
        :key="rowIndex" :ref="`tlRow${rowIndex}`"
        :style="{ 'z-index': timeLineNodes.length - rowIndex }"
      >
        <template v-for="(item, index) in rowItem" :key="index">
          <!-- 左括号 -->
          <div
            v-if="item.marker === 'left-end'"
            class="tl-item-with-end left-end-item"
            :class="{
              'tl-item-gray': !item.active,
              'tl-item-sample': showSample,
            }"
            :ref="`tlItem${item.year}`"
          >
            <div class="line-wrap left-line-wrap"></div>
            <div class="tl-content">
              <div class="tl-icon d-flex justify-content-center align-items-center" :style="bgStyle" v-html="item.iconSvg"></div>
              <div class="tl-content-text tl-content-text-right">
                <div class="tl-content-sm-title">{{ item.device_name }}</div>
                <div class="tl-content-title cursor-pointer" @click="jumpPage(item)">{{ item.title }}</div>
                <div class="d-flex align-items-center" v-if="item.content"><i class="ri-information-fill me-1"></i>{{ getContentText(item) }}</div>
                <div class="tl-content-description">{{ item.description }}</div>
              </div>
            </div>
          </div>

          <!--  右括号-->
          <div
            v-if="item.marker === 'right-end'"
            class="tl-item-with-end right-end-item"
            :class="{
              'tl-item-gray': !item.active,
              'tl-item-sample': showSample,
            }"
            :ref="`tlItem${item.year}`"
          >
            <div class="line-wrap right-line-wrap"></div>
            <div class="tl-content">
              <div class="tl-icon d-flex justify-content-center align-items-center" :style="bgStyle" v-html="item.iconSvg"></div>
              <div class="tl-content-text tl-content-text-left">
                <div class="tl-content-sm-title">{{ item.device_name }}</div>
                <div class="tl-content-title cursor-pointer" @click="jumpPage(item)">{{ item.title }}</div>
                <div class="d-flex align-items-center"  v-if="item.content"><i class="ri-information-fill me-1"></i>{{ getContentText(item) }}</div>
                <div class="tl-content-description">{{ item.description }}</div>
              </div>
            </div>
          </div>

          <!--  正常节点-->
          <div
            v-if="!item.marker"
            class="tl-item"
            :class="{
              'tl-item-gray': !item.active,
              'tl-item-sample': showSample,
            }"
            :ref="`tlItem${item.year}`"
          >
            <div class="tl-content">
              <div class="tl-content-text">
                <div class="tl-content-sm-title">{{ item.device_name }}</div>
                <div class="tl-content-title cursor-pointer" @click="jumpPage(item)">{{ item.title }}</div>
                <div class="d-flex align-items-center" v-if="item.content"><i class="ri-information-fill me-1"></i>{{ getContentText(item) }}</div>
                <div class="tl-content-description">{{ item.description }}</div>
              </div>
              <div class="tl-icon d-flex justify-content-center align-items-center" :style="bgStyle" v-html="item.iconSvg"></div>
            </div>
          </div>
          <!--  空 没有border-->
          <!--        <div class="tl-item-empty no-border"></div>-->
          <!--  空 灰色虚线-->
          <div v-if="item.marker === 'empty'" class="tl-item-empty" :class="{
            'tl-item-sample': showSample,
          }"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Mark from 'mark.js'
import _ from 'lodash'
import * as LifecycleConfig from '@/config/instance-lifecycle'
import { getInstancesLifecycle, getCustomerContractDetail, getEventsDetail } from '@/service/index'
import { formatDatetime } from "@/helpers/common";
import { maintenanceItemList } from '@/utils/selectText'
import { getLanguage } from "@/i18n";
export default {
  props: {
    instanceId: {
      type: [Number, String],
      required: true,
    },
    bgBackgroundColor: {
      type: String,
      default: '#f3f3f9'
    },
    instanceInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      bgStyle: {
        background: this.bgBackgroundColor,
      },
      items: [], // 按时间节点升序排列的数据，越晚发生的在后面
      currentYear: null,
      searchKeyword: null,
      marks: [],
      currentMarkIndex: 0,
      rafId: null, // Add a property to store the requestAnimationFrame ID
      isProgrammaticScroll: false,
      showSample: false,
      innerWidth: window.innerWidth,
      timeLineNodes: [],
    };
  },
  computed: {
    years() {
      // 没有数据时返回当前年份
      if (!this.items.length) return [new Date().getFullYear()]
      const years = this.items.map(item => item.year)
      return [...new Set(years)].sort((a, b) => b - a)
    },
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },
  },
  created() {
    // const startYear = 2019
    // for (let i = 0; i< 56; i++) {
    //   let year = startYear + Math.floor(i / 10)
    //   this.items.push({
    //     title: '设备出厂' + i,
    //     description: year+'年01月01日 17:00:00',
    //     icon:LifecycleConfig.Icons[`Img${i%17+1}`],
    //     active: year > 2023 ? false : true,
    //     year: year,
    //     content: '',
    //     source_type: LifecycleConfig.LIFE_CYCLE_SOURCE_TYPE_CONTRACT,
    //     source_id: 17,
    //   })
    // }
    // this.items[55].content = '一级保养'
    // this.items[55].description += '(剩余12天)'
  },
  mounted() {
    // if (this.items.length) return
    // console.log(this.instanceI d)
    // this.getLifecycleNodes()
    var _this = this;
    window.onresize = function(){ // 定义窗口大小变更通知事件
        _this.innerWidth = window.innerWidth;
    };
    this.$nextTick(() => {
      const _currentYear = new Date().getFullYear();
      this.scrollTo(_currentYear)
    })
  },
  methods: {
    getLanguage,
    // 获取节点
    getLifecycleNodes() {
      getInstancesLifecycle(this.instanceId)
      .then(res => {

        let data = _.cloneDeep(res.payload)
        //造纸厂展示内容
        if(this.isPaperMaking){ 
            data.push({
              "id": 9,
              "device_name": this.instanceInfo.name||"",
              "source_type": this.instanceInfo.product_type||"",
              "source_id": this.instanceInfo.id||"",
              "icon": "G",
              "title": "下次保养",
              "content": "4", //日常保养
              "lc_time": "2026-04-27T00:00:00Z",
              "created_at": 1731947405040,
              "created_by": 0,
              "device":this.instanceInfo.id||"",
          })
          data = _.sortBy(data, 'lc_time');   //日期排序  
        }

        this.items = data.map(item => {
          let datetimeFormatStr = LifecycleConfig.getIconTimeFormat(item.icon)
          item.year = new Date(item.lc_time).getFullYear()
          item.iconSvg = LifecycleConfig.getIcon(item)
          item.active = LifecycleConfig.nodeActive(item)
          
          if (!item.active) {
            item.description = `${formatDatetime(item.lc_time, datetimeFormatStr)}(${this.$t('page.repair-request.remaining')}${LifecycleConfig.getLeftDays(item)}${this.$t('page.atlas-analysis.day')})`
          } else {
            item.description = `${formatDatetime(item.lc_time, datetimeFormatStr)}`
          }

          //翻译title
          if(item.title){
            item.title = this.$t(`${item.title}`)
          }
          return item
        })
        console.log("items:",this.items);
        
      })
      .then(() => {
        if (!this.items.length) {
          this.showSample = true
          this.items = LifecycleConfig.sampleData
          return
        }
        this.showSample = false
        this.$nextTick(() => {
          // this.currentYear = this.years[0]
          // 监听滚动
          window.addEventListener('scroll', this.throttledCheckCurrentYear);
        })
        
        this.timeLineNodes = this.processItems(this.items)
        
      })
    },
    // 滚动到指定元素的位置
    scrollToEl(el) {
      if (el) {
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const elHeight = rect.height;
        const top = rect.top + window.pageYOffset - (windowHeight - elHeight) / 2;
        this.isProgrammaticScroll = true;
        window.scrollTo({ top: top, behavior: "smooth" });
        setTimeout(() => {
          this.isProgrammaticScroll = false;
        }, 1000); // 设置恢复时间，可以根据需要调整，确保平滑滚动完成后再切换
      }
    },
    // 页面滚动到指定年份第一次出现的位置
    scrollTo(year) {
      this.currentYear = year
      let tlItemYear = this.$refs[`tlItem${year}`]
      if (tlItemYear && tlItemYear.length > 0) {
        const el = tlItemYear[0]
        this.scrollToEl(el)
      }
    },
    throttledCheckCurrentYear() {
      if (this.isProgrammaticScroll) {
        return;
      }
      if (!this.rafId) {
        this.rafId = window.requestAnimationFrame(() => {
          this.checkCurrentYear();
          this.rafId = null; // Clear the stored ID to ensure future invocations
        });
      }
    },
    checkCurrentYear() {
      let currentYear = null;
      let minDistance = Infinity;

      for (let year of this.years) {
        let tlItemYear = this.$refs[`tlItem${year}`]
        if (!tlItemYear || tlItemYear.length == 0) {
          continue
        }
        const el = tlItemYear[0]
        if (el) {
          const rect = el.getBoundingClientRect();
          const distanceToCenter = Math.abs(rect.top + rect.height / 2 - window.innerHeight / 2);

          if (distanceToCenter < minDistance) {
            minDistance = distanceToCenter;
            currentYear = year;
          }
        }
      }

      // Set the current year to the closest year to the center of viewport
      this.currentYear = currentYear;
    },
    markSearch() {
      const instance = new Mark(this.$refs.tlWrap);
      instance.unmark(); // 首先清除之前的高亮
      this.marks = []
      if (!this.searchKeyword) {
        return;
      }
      for (let i = this.timeLineNodes.length - 1; i >=0; i--) {
        let rowEl = this.$refs[`tlRow${i}`]
        let markInstance = new Mark(rowEl);
        markInstance.mark(this.searchKeyword, {
          // 高亮搜索到的关键词
          className: "highlight-timeline", // 应用高亮样式
          done: () => {
            // 把这一行高亮的所有元素追加到this.marks中
            let currentRowMarks = rowEl[0].querySelectorAll(".highlight-timeline")
            if (i % 2 === 0) {
              // 偶数行，反转顺序
              currentRowMarks = Array.from(currentRowMarks);
              currentRowMarks.reverse();
            }
            this.marks = [...this.marks, ...currentRowMarks];
            if (i === 0) {
              // 最后一行高亮完成后，更新当前高亮元素
              this.updateCurrentHighlight(0)
            }
          },
        });
      }
    },
    debouncedMarkSearch: _.debounce(function () {
      this.markSearch();
    }, 300),
    scrollToNext() {
      if (this.marks.length > 0) {
        // 如果有高亮元素，滚动到下一个
        const newIndex = (this.currentMarkIndex + 1) % this.marks.length;
        this.updateCurrentHighlight(newIndex)
      }
    },
    scrollToPrev() {
      if (this.marks.length > 0) {
        // 如果有高亮元素，滚动到上一个
        const newIndex = (this.currentMarkIndex + this.marks.length - 1) % this.marks.length;
        this.updateCurrentHighlight(newIndex);
      }
    },
    updateCurrentHighlight(newIndex) {
      // 移除之前选中元素的.current-highlight类
      if (this.currentMarkIndex >= 0) {
        this.marks[this.currentMarkIndex].classList.remove("current-highlight");
      }
      // 为新选中元素添加.current-highlight类
      this.currentMarkIndex = newIndex;
      if (this.currentMarkIndex >= 0) {
        this.marks[this.currentMarkIndex].classList.add("current-highlight");
        this.scrollToEl(this.marks[this.currentMarkIndex])
      }
    },
    jumpPage(item) {
      // 设备出厂---跳设备详情页
      if (item.source_type == LifecycleConfig.LIFE_CYCLE_SOURCE_TYPE_DEVICE) {
        const routePath = this.$router.resolve({
          path: "/equipment-detail",
          query: {
            equip_id: item.source_id,
          },
        });
        window.open(routePath.href, '_blank')
        return
      }
      // 跳工单详情页
      if (item.source_type == LifecycleConfig.LIFE_CYCLE_SOURCE_TYPE_ORDER) {
        // 记录当前tab
        // localStorage.setItem('instanceDetailCurrentTab', 'fullLifecycle')
        const routePath = this.$router.resolve({
          path: `/work-order-detail/${item.source_id}`,
        })
        window.open(routePath.href, '_blank')
        return
      }
      // 跳合同详情
      if (item.source_type == LifecycleConfig.LIFE_CYCLE_SOURCE_TYPE_CONTRACT) {
        // 获取合同详情，跳转到客户详情页，提示打开合同详情
        getCustomerContractDetail(item.source_id).then(res => {
          const contractDetail = res.payload
          const routePath = this.$router.resolve({
            path: `/customer/${contractDetail.party_a}`,
          })
          localStorage.setItem('contractDetail', JSON.stringify(contractDetail))
          window.open(routePath.href, '_blank')
        })
        return
      }
      // 跳事件详情
      if (item.source_type == LifecycleConfig.LIFE_CYCLE_SOURCE_TYPE_EVENT) {
        let params = {
          eventId: item.source_id,
          type: "TRACK_ID",
        };
        getEventsDetail(params.eventId, params).then(detailRes => {

          const routePath = this.$router.resolve({
            path: `/iot/event-management`,
          })

          const eventDetail = {
            ...detailRes.payload,
            deviceDetail: this.instanceInfo
          }

          localStorage.setItem('eventDetail', JSON.stringify(eventDetail))
          localStorage.setItem('instanceDetail', JSON.stringify(this.instanceInfo))
          localStorage.setItem('fromLifecycle', 'true')
          window.open(routePath.href, '_blank')
          // window.location.href = routePath.href

        })

        return;
      }
    },
    processItems(items) {
      const rows = [];
      let rowIndex = 0;
      let lineMax = parseInt((window.innerWidth - 480) / 260)
      lineMax = lineMax > 6 ? 6 : lineMax
      lineMax = lineMax < 1 ? 1 : lineMax

      // 第一行
      let firstRowItems = items.slice(0, lineMax);
      // 不足6个，用空节点补齐
      while (firstRowItems.length < lineMax) {
        firstRowItems.push({ title: "", description: "", icon: "", marker: "empty" });
      }
      rows.push(firstRowItems);
      rowIndex++;

      // 其余行
      while (items.length > rowIndex * (lineMax + 1) - 1) {
        const start = rowIndex * (lineMax + 1) - 1;
        const end = start + (lineMax + 1);
        let rowItems = items.slice(start, end);
        // 不足6个，用空节点补齐
        while (rowItems.length < (lineMax + 1)) {
          rowItems.push({ title: "", description: "", icon: "", marker: "empty" });
        }
        // 下标为偶数的行从左到右，第一个标记为left-end，下标为奇数的行从右到左，最后一个标记为right-end
        if (rowIndex % 2 === 1) {
          rowItems.reverse();
          rowItems[rowItems.length - 1] = { ...rowItems[rowItems.length - 1], marker: "right-end" };
        }
        else {
          rowItems[0] = { ...rowItems[0], marker: "left-end" };
        }

        rows.push(rowItems);
        rowIndex++;
      }

      return rows;
    },
    getContentText(source) {
      if (source.icon == "G") {
        const result = maintenanceItemList.find(item => item.value == source.content)
        if (!result) {
          return '-'
        }
        return result.label
      }
      else {
        return source.content
      }
    }
  },
  watch: {
    instanceId: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          this.getLifecycleNodes();
        }
      },
      immediate: true
    },
    'innerWidth': {
      handler: function(val){ //监听屏幕宽度变化
        this.timeLineNodes = this.processItems(this.items)
      },
      immediate: true
    },
  }
}
</script>

<style lang="scss" scoped>
/*线条的颜色*/
$activeLineColor: #6691E7;
$inActiveLineColor: #c6cccc;
/*线条的粗细*/
$lineWidth: 3px;
/*节点标题的颜色*/
$activeTitleColor: $activeLineColor;
$inActiveTitleColor: #6D7080;
/* 示例节点的颜色 */
$sampleNodeColor: rgba(64, 81, 137, 0.2);
/*每个节点的宽高*/
$nodeWidth: 260px;
$nodeHeight: 220px;
/*端点宽度*/
$itemWithEndWidth: 100px;

.sample-cover {
  width: 100%;
  height: 100%;
  background-color: #f1f1f84d;
  display: flex;
  justify-content: center;
  align-items: center;
  //padding-top: 17%;
  z-index: 2000;
  .sample-cover-text {
    margin-top: -70px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 0.2px;
    color: #212529;
  }
}
.tl-wrap {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  padding-top: 120px;
  width: 100%;
  //min-width: 1490px;
  //overflow: auto;
  .tl-row {
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
  }
  /*除第一行外的其他行*/
  .tl-row:not(:first-child) {
    margin-bottom: -($lineWidth);
  }
  /*除第一行外的奇数行*/
  .tl-row:nth-child(2n+3) {
    margin-left: -($itemWithEndWidth);
  }
  .tl-row:nth-child(even) {
    margin-right: -($itemWithEndWidth);
  }
}
.tl-icon {
  width: 50px;
  height: 50px;
}

.tl-content-text {
  position: absolute;
  width: max-content;
  min-width: 120px;
  max-width: $nodeWidth;
  //height: 100px;
}

.tl-content-title {
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;
  color: $activeTitleColor;
}
.tl-content-sm-title {
  color: $activeTitleColor;
  font-weight: 500;
}
.tl-content-description {
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  color: #212529;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制最多显示2行 */
  line-clamp: 2; /* 限制最多显示2行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 指定文本溢出的显示方式为省略号 */
}

.tl-item {
  position: relative;
  border-top: $lineWidth solid $activeLineColor;
  width: $nodeWidth;
  height: $nodeHeight;
  .tl-content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -25px;
    .tl-content-text {
      //top: -77px;
      bottom: 50px;
    }
  }
}
.tl-item.tl-item-sample {
  border-top: $lineWidth solid $sampleNodeColor;
}
/*第一个节点只显示一半的border*/
.tl-row:first-child .tl-item:first-child::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%; /* 从左侧的50%位置开始显示 */
  border-top: $lineWidth solid $activeLineColor;
  width: 50%; /* 控制边框的长度百分比 */
}
.tl-row:first-child .tl-item.tl-item-sample:first-child::before {
  border-top: $lineWidth solid $sampleNodeColor;
}
.tl-row:first-child .tl-item.tl-item-gray:first-child::before {
  border-top: $lineWidth dashed $inActiveLineColor;
}
.tl-row:first-child .tl-item:first-child {
  border-top: none;
}

.tl-item-empty {
  position: relative;
  border-top: $lineWidth dashed $inActiveLineColor;
  width: $nodeWidth;
  height: $nodeHeight;
}
.tl-item-empty.tl-item-sample {
  border-top: $lineWidth dashed $sampleNodeColor;
}
.tl-item-empty.no-border {
  border-top: none;
}

.tl-item-with-end {
  position: relative;
  z-index: 1000;
  width: $itemWithEndWidth;
  height: $nodeHeight;
  display: flex;
  align-items: center;
  justify-content: center;
  .line-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      border: $lineWidth solid $activeLineColor;
      border-radius: 50%;
    }
  }
  .tl-content {
    position: relative;
    .tl-content-text {
      position: absolute;
      top: 0;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}

.tl-item-with-end.tl-item-sample .line-wrap::before {
  border: $lineWidth solid $sampleNodeColor;
}

.left-line-wrap {
  &::before {
    left: 50%;
  }
}
.right-line-wrap {
  &::before {
    right: 50%;
  }
}

.tl-content-text-right {
  left: 100%;
  align-items: flex-start;
  padding-left: 5px;
}
.tl-content-text-left {
  right: 100%;
  align-items: flex-start;
  padding-right: 5px;
}

.tl-item-gray:not(.tl-item-with-end) {
  border-top: $lineWidth dashed $inActiveLineColor;
}
.tl-item-with-end.tl-item-gray .line-wrap::before {
  border: $lineWidth dashed $inActiveLineColor;
}
.tl-item-gray.tl-item-sample:not(.tl-item-with-end) {
  border-top: $lineWidth dashed $sampleNodeColor;
}
.tl-item-with-end.tl-item-gray.tl-item-sample .line-wrap::before {
  border: $lineWidth dashed $sampleNodeColor;
}

.tl-item-gray .tl-content-title {
  color: $inActiveTitleColor;
}
.tl-item-gray .tl-content-sm-title {
  color: $inActiveTitleColor;
}
.tl-item-gray .tl-icon {
  filter: grayscale(100%);
}
.tl-item-sample .tl-content-title {
  color: $sampleNodeColor;
}
.tl-item-sample .tl-icon {
  filter: grayscale(0%);
}

.toolbox {
  position: relative;
  width: 100%;
  z-index: 100;
}
.filter-tool {
  position: relative;
  .input-group {
    width: 200px;
    float: right;
    border: 1px solid var(--vz-input-border);
    border-radius: 0.25rem;
    .input-group-text {
      background: none;
      border: none;
      color: #9599AD;
    }
    .search-input {
      background: none;
      border: none;
    }
    .arrows {
      line-height: initial;
      flex-direction: column;
      padding: 0px 8px;
      justify-content: center;
      i {
        font-size: 1.5rem;
        line-height: 0.8rem;
        cursor: pointer;
        &:hover {
          color: var(--vz-primary);
        }
      }
    }
  }
}
.filter-tool.active {
  position: fixed;
  right: 4%;
}
.years-nav {
  position: fixed;
  .year-item {
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;
    .year-item-icon {
      width: 23px;
      height: 5px;
      background: rgba(64, 81, 137, 0.2);
      border-radius: 5px;
      margin-right: 10px;
    }
    .year-item-text {
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      color: #979797;
    }
  }
  .year-item.active {
    .year-item-icon {
      background: #6691E7;
    }
    .year-item-text {
      color: #495057;
      font-size: 16px;
      line-height: 22px;
    }
  }
}

</style>
<style lang="scss">
/* 高亮样式 */
.highlight-timeline {
    background-color:  var(--vz-highlight-bg);
}
.current-highlight {
    background: yellow;
    border-radius: 5px;
}
</style>
